import { FC, useState } from "react";
import { Button, Card, Col } from "react-bootstrap";
import { DevProductsData, Organization, Product } from "../../models/types";
import { useQuery } from "@apollo/client";
import { GET_DEV_PRODUCTS } from "../../graphql/queries";
import { NewProductModal } from "../modals/NewProductModal";
import { SearchableDropdown } from "../dropdowns/SearchableDropdown";

interface Props {
    organization: Organization;
    product: Product | undefined;
    updateProduct: (selectedProduct: Product) => void;
}

export const ProductSelectionView: FC<Props> = ({
    organization,
    product,
    updateProduct
}) => {
    const [showModal, updateModal] = useState(false);
    const { data: { devProducts } = {} } =
        useQuery<DevProductsData>(GET_DEV_PRODUCTS);
    const products = devProducts?.flatMap((product: Product) =>
        product.organization.id === organization.id ? product.name : []
    );
    return (
        <Card className="border-info my-2">
            <div className="py-2">
                <Col className="m-0 ps-2 mb-2" md={12}>
                    <h5 className="text-inverse p-2">Product</h5>
                </Col>
                <Col
                    md={12}
                    className="d-flex justify-content-center align-content-center px-4 mb-3"
                >
                    <SearchableDropdown
                        selectedValue={
                            product === undefined
                                ? "Select Product"
                                : product.name
                        }
                        variant="info"
                        placeholder="Select Product"
                        choices={products}
                        onSelect={(selectedItem: string | null | undefined) => {
                            if (selectedItem) {
                                const selectedProduct = devProducts?.find(
                                    element => element.name === selectedItem
                                );
                                if (selectedProduct) {
                                    updateProduct(selectedProduct);
                                }
                            }
                        }}
                    />
                    <Button className="ms-2" onClick={() => updateModal(true)}>
                        New Product
                    </Button>
                    {showModal ? (
                        <NewProductModal
                            show={showModal}
                            onClose={newProduct => {
                                if (newProduct) {
                                    updateProduct(newProduct);
                                }
                                updateModal(false);
                            }}
                            defaultOrganization={organization}
                        />
                    ) : null}
                </Col>
            </div>
        </Card>
    );
};
